/*
  Read more / Read less for the collapsed collection description (main-collection-banner).

  The description is clamped to N lines by CSS (.is-clamped). The Read more link starts hidden
  and is shown only when the text overflows, which is re-checked on resize and once fonts load.
  The link's label comes from data-read-more / data-read-less so it stays translatable.
*/
(function () {
  document.querySelectorAll('[data-collapsible-description]').forEach(function (description) {
    if (description.dataset.toggleBound) return;
    description.dataset.toggleBound = 'true';

    var button = document.querySelector('[aria-controls="' + description.id + '"]');
    if (!button) return;

    function sync() {
      // Only measure while clamped; once expanded the link stays so the text can be collapsed again.
      if (!description.classList.contains('is-clamped')) return;
      button.hidden = description.scrollHeight <= description.clientHeight + 1;
    }

    button.addEventListener('click', function () {
      var expanded = description.classList.toggle('is-clamped') === false;
      button.setAttribute('aria-expanded', String(expanded));
      button.textContent = expanded ? button.dataset.readLess : button.dataset.readMore;
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(sync, 100);
    });

    if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync);
    sync();
  });
})();
